import * as TypeGraphQL from "type-graphql";
export var SessionScalarFieldEnum;
(function (SessionScalarFieldEnum) {
    SessionScalarFieldEnum["id"] = "id";
    SessionScalarFieldEnum["sessionToken"] = "sessionToken";
    SessionScalarFieldEnum["userId"] = "userId";
    SessionScalarFieldEnum["expires"] = "expires";
    SessionScalarFieldEnum["createdAt"] = "createdAt";
    SessionScalarFieldEnum["updatedAt"] = "updatedAt";
})(SessionScalarFieldEnum || (SessionScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(SessionScalarFieldEnum, {
    name: "SessionScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=SessionScalarFieldEnum.js.map